import cx from "classnames";
import PrevNextPaginatorButton from "./components/PrevNextPaginatorButton/PrevNextPaginatorButton";
import PrevNextPaginatorLabel from "./components/PrevNextPaginatorLabel/PrevNextPaginatorLabel";
import type { PrevNextPaginatorProps } from "./PrevNextPaginator.types";

const PrevNextPaginator = ({
  current,
  onChange,
  pagesCount,
  className,
  iconSize,
  Label = PrevNextPaginatorLabel,
  children,
  slotProps,
}: PrevNextPaginatorProps) => {
  const label = children ?? <Label current={current} pagesCount={pagesCount} />;

  if (pagesCount <= 1) {
    return label;
  }

  return (
    <div
      className={cx("flex items-center gap-1", className)}
      data-test-id="prev-next-paginator"
    >
      <PrevNextPaginatorButton
        direction="prev"
        disabled={current === 0}
        onClick={() => onChange(Math.max(current - 1, 0))}
        iconSize={iconSize}
        slotProps={{
          iconButton: slotProps?.prevIconButton,
          tooltip: slotProps?.prevTooltip,
        }}
      />

      {label}

      <PrevNextPaginatorButton
        direction="next"
        disabled={current === pagesCount - 1}
        onClick={() => onChange(Math.min(current + 1, pagesCount - 1))}
        iconSize={iconSize}
        slotProps={{
          iconButton: slotProps?.nextIconButton,
          tooltip: slotProps?.nextTooltip,
        }}
      />
    </div>
  );
};

export default PrevNextPaginator;
